export const GET_THEMES = 'GET_THEMES'
export const GET_THEMES_SUCCESS = 'GET_THEMES_SUCCESS'
export const GET_THEMES_FAILED = 'GET_THEMES_FAILED'

export const GET_THEME = 'GET_THEME'
export const GET_THEME_SUCCESS = 'GET_THEME_SUCCESS'
export const GET_THEME_FAILED = 'GET_THEME_FAILED'

export const CREATE_THEME = 'CREATE_THEME'
export const CREATE_THEME_SUCCESS = 'CREATE_THEME_SUCCESS'
export const CREATE_THEME_FAILED = 'CREATE_THEME_FAILED'

export const UPDATE_THEME = 'UPDATE_THEME'
export const UPDATE_THEME_SUCCESS = 'UPDATE_THEME_SUCCESS'
export const UPDATE_THEME_FAILED = 'UPDATE_THEME_FAILED'

export const DELETE_THEME = 'DELETE_THEME'
export const DELETE_THEME_SUCCESS = 'DELETE_THEME_SUCCESS'
export const DELETE_THEME_FAILED = 'DELETE_THEME_FAILED'

export const RESET_THEME_STATE = 'RESET_THEME_STATE'

export const FILEUPLOAD = 'FILEUPLOAD'
export const FILEUPLOAD_SUCCESS = 'FILEUPLOAD_SUCCESS'
export const FILEUPLOAD_FAILED = 'FILEUPLOAD_FAILED'
